/**
 * Suche in den Listen (Verwaltung und Mitarbeiter).
 * Filtert die Zeilen einer Liste nach den Feldern aus data-suche-felder.
 */

window.myHandlers = window.myHandlers || {};

// Timer für das verzögerte Filtern je Suchfeld
const sucheTimer = new WeakMap();

// Ändert sich ein Feld einer Zeile, muss der gecachte Suchtext der Zeile neu gelesen werden.
document.addEventListener('input', (event) => {
	const zeile = event.target.closest?.('.lohnarten-liste .liste-zeile');
	if (zeile) {
		delete zeile.dataset.suchtext;
	}
});

/**
 * Event Handler der Suche: filtert verzögert (debounce), damit nicht jeder Tastendruck filtert.
 * @param {HTMLElement} thisElement Suchfeld
 * @param {String} prefix z.B. 'la-', 'bdp-', 'nba-', 'u-la-' oder 'u-nba-'
 */
export function filtereListe(thisElement, prefix) {
	clearTimeout(sucheTimer.get(thisElement));
	sucheTimer.set(thisElement, setTimeout(() => filtereListeSofort(thisElement, prefix), 120));
}

/**
 * Filtert die Zeilen einer Liste nach den Feldern aus data-suche-felder.
 * Zeilen werden nur ein- bzw. ausgeblendet, die Liste wird nicht neu aufgebaut.
 * Mehrere durch Leerzeichen getrennte Suchbegriffe müssen alle zutreffen.
 * @param {HTMLElement} thisElement Suchfeld
 * @param {String} prefix z.B. 'la-', 'bdp-', 'nba-', 'u-la-' oder 'u-nba-'
 */
function filtereListeSofort(thisElement, prefix) {
	clearTimeout(sucheTimer.get(thisElement));
	const begriffe = thisElement.value.toLowerCase().split(/\s+/).filter(Boolean);
	// Durchsuchte Felder können per data-suche-felder (kommagetrennt) festgelegt werden.
	// Felder, die eine Liste nicht hat (z.B. Exportnummer), werden ignoriert.
	const felder = (thisElement.dataset.sucheFelder ?? '').split(',');
	const panel = thisElement.closest('.panel');
	const zeilen = panel.querySelectorAll(`.${prefix}zeile:not(.header)`);
	let treffer = 0;
	zeilen.forEach((zeile) => {
		// Suchtext wird je Zeile einmal gelesen und gecached
		if (zeile.dataset.suchtext === undefined) {
			zeile.dataset.suchtext = felder
				.map((feld) => zeile.querySelector(`[aria-label="${prefix}${feld}"]`)?.value ?? '')
				.join(' ')
				.toLowerCase();
		}
		const sichtbar = begriffe.every((begriff) => zeile.dataset.suchtext.includes(begriff));
		// Nur schreiben, wenn sich der Zustand ändert
		const versteckt = zeile.style.display === 'none';
		if (sichtbar === versteckt) {
			zeile.style.display = sichtbar ? '' : 'none';
		}
		if (sichtbar) {
			treffer++;
		}
	});
	panel.querySelector('.listen-suche-leeren').hidden = begriffe.length === 0;
	const zaehler = panel.querySelector('.listen-suche-zaehler');
	if (begriffe.length === 0) {
		zaehler.textContent = '';
	} else {
		zaehler.innerHTML = treffer === 0 ? 'Keine Treffer' : `<b>${treffer}</b> von ${zeilen.length}`;
	}
}

/**
 * Leert das Suchfeld der Liste und zeigt wieder alle Zeilen an.
 * @param {HTMLElement} thisElement Suchfeld oder Button zum Leeren
 */
export function leereListenSuche(thisElement) {
	const suchfeld = thisElement.closest('.listen-suche').querySelector('input');
	suchfeld.value = '';
	filtereListeSofort(suchfeld, suchfeld.dataset.suche);
	suchfeld.focus();
}

/**
 * Wendet den aktuellen Suchtext erneut an, nachdem die Liste neu aufgebaut wurde.
 * @param {String} prefix z.B. 'la-', 'bdp-', 'nba-', 'u-la-' oder 'u-nba-'
 */
export function wendeListenSucheAn(prefix) {
	// Es kann mehrere Listen mit demselben Prefix geben (z.B. Einsatzorte je Betriebsstätte)
	document.querySelectorAll(`[data-suche="${prefix}"]`).forEach((suchfeld) => {
		filtereListeSofort(suchfeld, prefix);
	});
}

window.myHandlers.filtereListe = filtereListe;
window.myHandlers.leereListenSuche = leereListenSuche;
